import Button from '../Button';
import { ButtonContainer } from '../Form';
import { Modal } from '../Modal';
import styled from 'styled-components';
import { useUpdateAccountInfoMutation } from '../../Account/api';
import { useAppSelector, useAppDispatch } from '../../reduxstore/hooks';
import { hideTermsPrompt } from '../../domains/UI/store/slice';
interface PromptModalProps {
	isOpen: boolean;
	toggleHandler: () => void;
}

export const PromptModal = ({
	isOpen,
	toggleHandler
}: PromptModalProps): JSX.Element => {
	const userId = useAppSelector(state => state.authReducer.id);
	const profile = useAppSelector(state => state.accountReducer.profile);
	const dispatch = useAppDispatch();

	const [updateAccountInfo, { isLoading }] = useUpdateAccountInfoMutation();

	const handleAcceptTerms = () => {
		const payload = {
			acknowledged_terms: true,
			...profile,
			id: userId
		};

		updateAccountInfo(payload);

		dispatch(hideTermsPrompt());
	};

	return (
		<Modal isOpen={isOpen} toggleHandler={toggleHandler}>
			<p>
				We've updated our Terms and Conditions. Please acknowledge and
				accept before proceeding.
			</p>
			<p>
				<Link
					href="https://www.biggby.com/terms-of-service/"
					target="_blank"
					rel="noopener noreferrer"
				>
					Tap here to view the terms and conditions.
				</Link>
				<br />
				<Link
					href=" https://www.biggby.com/privacy-policy/"
					target="_blank"
					rel="noopener noreferrer"
				>
					Tap here to view the privacy policy.
				</Link>
			</p>
			<ButtonContainer>
				{/* add updateaccount api call here */}
				<Button $isLoading={isLoading} onClick={handleAcceptTerms}>
					Accept
				</Button>
			</ButtonContainer>
		</Modal>
	);
};

const Link = styled.a`
	color: #f47920;
`;
